import "./TheBigDay.module.css";
import Header from "@/reusable_sections/Header";
import ServingYourNeighborhood from "./sections/ServingYourNeighborhood";
import GlobalPremiereCountdown from "./sections/GlobalPremiereCountdown";
import OurSpecializedSolutions from "./sections/OurSpecializedSolutions";
import Footer from "@/reusable_sections/Footer";
export default function TheBigDayPage() {
  return <div>
      <Header />
      <ServingYourNeighborhood />
      <GlobalPremiereCountdown />
      <OurSpecializedSolutions />
      <Footer />
    </div>;
}